import { useEffect } from "react";
import { useCalculatorPersistence } from "../../../contexts/CalculatorPersistenceContext";
import { getValueAtPath } from "../../../utils/calculatorStorage";
import { FLOW_DEFAULT_CHOICES } from "../constants/flowPresentation";

export default function useFlowDefaults(storagePath, kind, enabled = true) {
  const { getSnapshot, setCalculatorValue } = useCalculatorPersistence();
  useEffect(() => {
    if (!enabled) return;
    Object.entries(FLOW_DEFAULT_CHOICES[kind]).forEach(([key, value]) => {
      const path = `${storagePath}.${key}`;
      if (!getValueAtPath(getSnapshot(), path)) setCalculatorValue(path, value, "");
    });
  }, [enabled, getSnapshot, kind, setCalculatorValue, storagePath]);
}
